import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ModuleErrorPage } from '@shared/development';

document.body.setAttribute('app-compatible', 'true');

if (environment.production) {
  enableProdMode();
}

function showIncompatibilityScreen() {
  const splash = document.getElementById('splash-screen');
  const incompatible = document.getElementById('incompatible');
  if (splash && incompatible) {
    splash.remove();
    incompatible.removeAttribute('style');
  }
}

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((error) => {
    new ModuleErrorPage(error).create();
    console.error(error);
    showIncompatibilityScreen();
  });
